// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessAlert_root__3qZuL"};